import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NeoBannerModal, { NeoBannerModalContent, NeoBannerModalParagraph } from '../components/modals/NeoBannerModal';
import { NeoGridCardsView } from '../components/ui/NeoGridCardsView';
import NeoPageLayout from '../components/ui/NeoPageLayout';
import { ATS_BLOG } from '../data/blog';

const BlogView: React.FC = () => {
    const navigate = useNavigate();
    const [showBlogArticle, setShowBlogArticle] = useState(false);
    const [displayArticle, setDisplayArticle] = useState<any>(null);

    useEffect(() => {
        const navbar = document.getElementById("navbar");
        navbar?.classList.add("white-bg");
    }, []);

    const openArticle = (article) => {
        setDisplayArticle(article);
        setShowBlogArticle(true);
    }

    return (
        <>
            <NeoPageLayout
                pageTitle="Blog - ATS Global"
                pageDescription="Complete and Tailored AI Solutions"
                isLoading={false}
                logoUrl={{
                    white: "/ATS_Global_Branding_SansNeo_White.png",
                    black: "ATS_Global_Branding_SansNeo_Black.png"
                }}
                logoStyle={{
                    height: "65px",
                }}
                logoAction={"/"}
                links={[
                    {
                        title: "project x",
                        action: "/project-x",
                    },
                    {
                        title: "about",
                        action: "/about",
                    },
                    {
                        title: "blog",
                        action: "/blog",
                        active: true
                    },
                    {
                        title: "team",
                        action: "/team",
                    },
                ]}
                mobileFooterLinks={[
                    {
                        title: "NeoAI",
                        action: "https://neoworlder.ai",
                    },
                    {
                        title: "NeoWorlder",
                        action: "https://neoworlder.com",
                    },
                    {
                        title: "Lootverse",
                        action: "https://lootverse.com",
                    },
                ]}
            >

                <NeoGridCardsView
                    id="articles"
                    onNavigateBack={() => navigate("/about")}
                    onNavigate={() => navigate("/team")}
                    gridCols={4}
                    gridSpacing={"20px"}
                    // pageStyle={{ paddingTop: "100px" }}
                    title="We Share"
                    subtitle="We produce a vast amount of information. Here is a curated selection to help you quickly grasp the essentials."
                    cardItems={ATS_BLOG.map(article => ({
                        content: (
                            <div className="py-[15px] px-[28px]">
                                <p className="text-[16px] font-semibold mb-[8px]">{article.title}</p>
                                <p className="text-[14px]">{article.content[0].toString().slice(0, 50)}...</p>
                            </div>
                        ),
                        onClick: () => openArticle(article),
                    }))}
                />
            </NeoPageLayout>

            {/* Blog articles */}
            <NeoBannerModal
                isOpen={showBlogArticle}
                title={<h1 className="modal-title">{displayArticle?.title}</h1>}
                subtitle={<h2 className="modal-description">{displayArticle?.subtitle}</h2>}
                headerBgImageUrl={displayArticle?.coverUrl}
                onClose={() => setShowBlogArticle(false)}
            >
                {
                    displayArticle?.content.map((block, index) => {
                        if (typeof block === "object") {
                            if (block.type === "youtube") {
                                return (
                                    <div className="mt-5">
                                        <iframe width="560" height="315" src={`https://www.youtube.com/embed/${block.videoId}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
                                    </div>
                                )
                            } else {
                                return (
                                    <NeoBannerModalContent key={'para-content' + index} title={block?.title}>
                                        <NeoBannerModalParagraph>{block?.content}</NeoBannerModalParagraph>
                                    </NeoBannerModalContent>
                                )
                            }

                        } else {
                            return (
                                <NeoBannerModalParagraph key={'para' + index}>{block}</NeoBannerModalParagraph>
                            )
                        }
                    })
                }
                {/* <NeoBannerModalContent title="1. Acceptance of Terms:">
                    <NeoBannerModalParagraph>
                        1.1 This Agreement presents the complete Terms and Conditions (the “Terms”) that apply to your use of services available at “neoworlder.com” and "NeoWorlder" (collectively, the
                        "Services") operated by NeoWorlder, LLC (referred to as "we," "us," or "our" herein). By accessing or using our Services, you confirm that you have read, understood, and agreed to
                        be bound by these Terms, including any future modifications.
                    </NeoBannerModalParagraph>
                    <NeoBannerModalParagraph>
                        1.2 If you are entering into this agreement on behalf of a company or other legal entity, you represent that you are authorized to bind such entity to these Terms, in which case
                        “you” or “your” will refer to such entity. If you do not agree to be bound by these Terms, you are not authorized to use the Services.
                    </NeoBannerModalParagraph>
                </NeoBannerModalContent> */}
            </NeoBannerModal>

        </>
    );
};

export default BlogView;
